function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "64",
  height: "64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M39.824 31.253l-11.516-6.638a.798.798 0 00-.88 0c-.263.176-.439.44-.439.748v13.274c0 .308.176.616.44.748a.848.848 0 00.44.131.848.848 0 00.439-.131l11.516-6.638c.264-.176.44-.44.44-.747 0-.308-.176-.616-.44-.747z",
  fill: "currentColor"
})));